import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn as clsx } from "../../../helpers/react.js";
import { s } from "../../../style.module-B2VZNtqv.js";
const TwinContainer = forwardRef(
  ({ className, children, ...rest }, ref) => /* @__PURE__ */ jsx("div", { ...rest, ref, className: clsx(s.twinContainer, className), children })
);
TwinContainer.displayName = "Modal.InputFields.TwinContainer";
export {
  TwinContainer
};
